import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  compact,
  filter,
  findIndex,
  get,
  noop,
  orderBy,
  debounce,
} from 'lodash';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import CaretDown from '@material-ui/icons/ArrowDropDown';
import CaretUp from '@material-ui/icons/ArrowDropUp';
import Refresh from '@material-ui/icons/Refresh';
import Sort from '@material-ui/icons/UnfoldMore';
import AddIcon from '@material-ui/icons/Add';

import immutableToJS from 'helpers/immutableToJS';
import {
  includesSearchText,
  scrollTo,
  dispatchRestMaker,
  isConsumer,
} from 'helpers/utils';
import { selectState } from 'redux/selectors';
import { isMobile } from 'helpers/detect-mobile';
import {
  AddSourceDialog,
  HeaderTitle,
  Helper,
  injectIntl,
  NotificationsDialog,
  Pagination,
  Paper,
  ScrollToTop,
  SearchComponent,
  PaginationContainer,
  Tooltip,
} from 'components';

import { currentUserSelector } from 'redux/auth/selectors';
import { markNotificationAsRead } from 'redux/notifications/actions';
import { broadCastGroupActions } from 'redux/users/actions';
import {
  lastNotificationSelector,
  notificationsCountSelector,
} from 'redux/notifications/selectors';
import Composer from 'routes/Sources/components/Composer';
import { pagination as paginationOptions } from 'constants/options';

const styles = theme => ({
  actionBtn: {
    backgroundColor: '#ffd24c',
    borderRadius: 5,
  },
  actionBtnLabel: {
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
  },
  actionAvailableListBtn: {
    backgroundColor: '#ef9c38',
    borderRadius: '50%',
    height: '54px',
    minWidth: '54px',
    marginRight: '10px',
  },
  actionAvailableListBtnLabel: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: 500,
  },
  badgeBtn: {
    backgroundColor: '#ff602e',
    color: 'white',
  },
  markAsReadBtn: {
    backgroundColor: '#95c05b',
    borderRadius: 5,
  },
  label: {
    fontSize: 20,
    textTransform: 'none',
  },
  notificationBadge: {
    [theme.breakpoints.down('xs')]: {
      right: -25,
    },
    backgroundColor: '#ff602e',
    right: -30,
  },
  sort: { textTransform: 'none' },
  tab: { backgroundColor: '#ffffff' },
  tabsContainer: {
    borderRadius: 5,
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
  },
  tabIndicator: { backgroundColor: '#5b98ed' },
  tabLabel: {
    fontWeight: 600,
    color: '#5b98ed',
  },
});

class ContactsList extends Component {
  static propTypes = {
    addFormTitle: PropTypes.string.isRequired,
    addTooltip: PropTypes.string.isRequired,
    classes: PropTypes.shape({}).isRequired,
    contactProfileKey: PropTypes.string.isRequired,
    contacts: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
    contactsRequesting: PropTypes.bool.isRequired,
    currentUser: PropTypes.shape({}),
    helper: PropTypes.string,
    isVendor: PropTypes.bool,
    label: PropTypes.arrayOf(PropTypes.string).isRequired,
    lastStoreNotification: PropTypes.shape({}),
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
    searchTooltip: PropTypes.string.isRequired,
    suid: PropTypes.string,
    storeNotificaitonCount: PropTypes.number,
    title: PropTypes.string.isRequired,
    type: PropTypes.string,

    CardComp: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    markNotificationAsRead: PropTypes.func.isRequired,
    onCreateContact: PropTypes.func.isRequired,
    onCreateContactSuccess: PropTypes.func,
    onListContacts: PropTypes.func.isRequired,
    onReadContact: PropTypes.func,
    onRemoveContact: PropTypes.func.isRequired,
    onUpdateContact: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    setExpanded: PropTypes.func,
    readUserBroadCastGroup: PropTypes.func.isRequired,
    userBroadCastGroups: PropTypes.arrayOf(
      PropTypes.string,
    ).isRequired,
    isRetailPage: PropTypes.bool,
  };

  static defaultProps = {
    currentUser: {},
    isVendor: false,
    helper: '',
    lastStoreNotification: null,
    storeNotificaitonCount: 0,
    suid: '',
    type: '',
    isRetailPage: false,

    onCreateContactSuccess: noop,
    onReadContact: noop,
    setExpanded: noop,
  }

  static contextTypes = {
    readOnly: PropTypes.bool,
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
    isConsumer: PropTypes.bool,
    isMember: PropTypes.bool,
  };

  state = {
    activeNotifications: [],
    addCustomerDialogOpen: false,
    currentPageIndex: 1,
    expanded: null,
    notificationsDialogOpen: false,
    searchText: '',
    sellerForNotifications: null,
    sortDirection: true,
    sortMethod: 'companyName',
    tabValue: 'normal',
  };

  componentWillMount() {
    const { readUserBroadCastGroup } = this.props;
    readUserBroadCastGroup('');
  }

  componentDidMount() {
    this.onReload();
  }

  componentWillReceiveProps({ isVendor }) {
    if (isVendor !== this.props.isVendor) {
      this.onReload();
    }
  }

  onCancelSearch = () => this.setState({ searchText: '', currentPageIndex: 1 });

  onPageClick = (currentPageIndex) => {
    setTimeout(() => scrollTo('tabs'), 100);
    this.setState({ currentPageIndex });
  };

  onReload = () => {
    const { onListContacts, isRetailPage } = this.props;
    onListContacts({ isRetail: isRetailPage });
    this.setState({
      addCustomerDialogOpen: false,
      currentPageIndex: 1,
      searchText: '',
      sortDirection: true,
      sortMethod: 'companyName',
    });
  }

  onSearchText = value => this.setState({
    searchText: value,
    currentPageIndex: 1,
  });

  onSortByGroup = () => {
    const { isVendor } = this.props;
    const contactGroupType = isVendor ? 'sellerGroupName' : 'buyerGroupName';
    this._sortByField(contactGroupType);
  }

  onSortByVendor = () => {
    this._sortByField('companyName');
  }

  onSortLatest = () => {
    this._sortByField('companyName');
  }

  onSortUpdates = () => {
    const sortMethod = 'updateCount';
    let { sortDirection } = this.state;
    const currentState = this.state.sortMethod;

    if (sortMethod === currentState) {
      sortDirection = !sortDirection;
      this.setState({ sortDirection });
    } else {
      this.setState({ sortMethod });
      sortDirection = false;
      this.setState({ sortDirection });
    }
  }

  getContacts = () => {
    const { isMember } = this.context;
    const { contactProfileKey, contacts, type, isVendor, currentUser } = this.props;
    const { searchText, sortDirection, sortMethod } = this.state;
    const currentAccount = (currentUser && currentUser.organizations && currentUser.organizations.length > 0 && currentUser.organizations[0].account) || {};
    const role = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[currentAccount.currentRoleId] || 'Personal';
    const sortMethods = [];
    const sortDirections = [`${sortDirection === true ? 'asc' : 'desc'}`];
    if (sortMethod === 'companyName') {
      sortMethods.push(r => (r[contactProfileKey] || {})[sortMethod]);
    } else if (sortMethod === 'updateCount') {
      sortMethods.push(sortMethod);
    } else if (sortMethod === 'buyerGroupName') {
      sortMethods.push(sortMethod);
    } else if (sortMethod === 'sellerGroupName') {
      sortMethods.push(sortMethod);
    }
    
    sortMethods.unshift(r => r.isDeleted ? {} : Boolean(get(r, 'sellerProfile.isOff')));
    sortDirections.unshift('asc');

    sortMethods.unshift(r => r.isDeleted);
    sortDirections.unshift('asc');

    sortMethods.unshift(r => r.isDeleted && isVendor ? r.requestorId != r.buyerId :
      r.requestorId === r.sellerId);
    sortDirections.unshift('asc');

    const preContacts = isMember === true && role !== 'Personal' && currentAccount ? contacts.filter(ct => ct.sellerProfile && ct.sellerProfile.id === currentAccount.id) : contacts;

    const sortedContacts = orderBy(
      preContacts,
      sortMethods,
      sortDirections,
    );
    const filteredContacts = sortedContacts.filter(contact => includesSearchText(searchText,
      contact[contactProfileKey] ? compact([
        contactProfileKey === 'buyerProfile' ? contact.buyerCompanyCode : contact.sellerCompanyCode,
        contactProfileKey === 'buyerProfile' ? contact.buyerGroupName : contact.sellerGroupName,
        contact[contactProfileKey].companyName,
        contact[contactProfileKey].email,
        contact[contactProfileKey].firstName,
        contact[contactProfileKey].lastName,
      ]) : [],
    ));

    if (type === 'stores') {
      const wareHouseIndex = findIndex(filteredContacts, ['id', 0]);
      if (wareHouseIndex !== -1) {
        filteredContacts.splice(wareHouseIndex, 1);
        filteredContacts.unshift({ id: 0 });
      }
    }

    return filteredContacts;
  };

  getTabFilteredContacts = (contacts) => {
    const { title, isVendor, type } = this.props;
    const { tabValue } = this.state;
    let filteredContacts = [];
    if (tabValue && (title === 'Vendors' || title === 'Customers')) {
      if (tabValue === 'normal') {
        filteredContacts = contacts.filter(contact => contact.isDeleted || !contact.requestorId);
      } else if (tabValue === 'invitations') {
        filteredContacts = contacts.filter(contact =>
          contact.requestorId &&
          (isVendor ?
            contact.requestorId === contact.sellerId && !contact.isDeleted :
            contact.requestorId === contact.buyerId && !contact.isDeleted
          ),
        );
      } else if (tabValue === 'requests') {
        filteredContacts = contacts.filter(contact =>
          contact.requestorId &&
          (isVendor ?
            contact.requestorId === contact.buyerId && !contact.isDeleted :
            contact.requestorId === contact.sellerId && !contact.isDeleted
          ),
        );
      }
    } else if (title === 'Availability Lists') {
      filteredContacts = contacts.filter(
        contact => !contact.requestorId || contact.isDeleted,
      );
    } else if (type === 'stores') {
      filteredContacts = contacts.filter(
        contact => !contact.requestorId && !get(contact, 'sellerProfile.isOff'),
      );
    } else {
      filteredContacts = contacts.filter(
        contact => !contact.requestorId || contact.isDeleted,
      );
    }
    return filteredContacts;
  }

  getUpdateCountsTotal = () => {
    const { contacts } = this.props;
    let total = 0;

    contacts.forEach((contact) => {
      total += contact.updateCount;
    });
    return total;
  }

  addCustomer = () => {
    this.handleAddCustomerDlgOpen();
  }

  addSourceItem = (data) => {
    const { onCreateContact } = this.props;
    onCreateContact({
      ...data,
      onSuccess: () => {
        this.props.onCreateContactSuccess();
        this.setState({
          addCustomerDialogOpen: false,
          tabValue: 'requests',
        });
        if (data.onSuccess) {
          data.onSuccess();
        }
      },
    });
  }

  showNotifications = (seller, notifications) => this.setState({
    activeNotifications: notifications,
    notificationsDialogOpen: true,
    sellerForNotifications: seller,
  });

  handleAddCustomerDlgClose = () => {
    this.setState({ addCustomerDialogOpen: false });
  };

  handleAddCustomerDlgOpen = () => {
    this.setState({ addCustomerDialogOpen: true });
  };

  handleNotificationsDlgClose = () => this.setState({ notificationsDialogOpen: false })

  handleChangeTab = (event, tabValue) => {
    this.setState({ tabValue });
  };

  _sortByField = (field) => {
    const sortMethod = field;
    const { sortDirection } = this.state;
    const currentState = this.state.sortMethod;

    if (sortMethod === currentState) {
      this.setState({ sortDirection: !sortDirection });
    } else {
      this.setState({ sortDirection: false, sortMethod });
    }
  }

  render() {
    const {
      addFormTitle,
      addTooltip,
      CardComp,
      classes,
      contactProfileKey,
      contactsRequesting,
      currentUser,
      helper,
      isVendor,
      label,
      location,
      push,
      searchTooltip,
      storeNotificaitonCount,
      suid,
      title,
      type,
      lastStoreNotification,
      formatMessage,
      onReadContact,
      setExpanded,
      userBroadCastGroups,
      isRetailPage,
      ...restProps
    } = this.props;
    const {
      isDistributor,
      isRestaurant,
      isConsumer,
      readOnly,
    } = this.context;
    const {
      activeNotifications,
      addCustomerDialogOpen,
      currentPageIndex,
      notificationsDialogOpen,
      searchText,
      sellerForNotifications,
      sortDirection,
      sortMethod,
    } = this.state;

    let iconDirectionForOrder = <Sort />;
    let iconDirectionForCustomer = <Sort />;
    let iconDirectionForGroup = <Sort />;

    const filteredContacts = this.getContacts();
    const contacts = this.getTabFilteredContacts(filteredContacts);
    const expanded = parseInt(suid, 10) || this.state.expanded;

    const countOfContacts = filter(filteredContacts, contact => contact.isDeleted
      || !contact.requestorId).length;
    const countOfInvitations = filter(
      filteredContacts,
      contact => (contact.requestorId && (isVendor ?
        contact.requestorId === contact.sellerId && !contact.isDeleted :
        contact.requestorId === contact.buyerId && !contact.isDeleted))).length;
    const countOfRequests = filter(
      filteredContacts,
      contact => (contact.requestorId && (isVendor ?
        contact.requestorId === contact.buyerId && !contact.isDeleted :
        contact.requestorId === contact.sellerId && !contact.isDeleted))).length;

    if (sortMethod === 'updateCount') {
      iconDirectionForCustomer = <Sort />;
      iconDirectionForOrder = sortDirection ? <CaretUp /> : <CaretDown />;
      iconDirectionForGroup = <Sort />;
    } else if (sortMethod === 'companyName') {
      iconDirectionForCustomer = sortDirection ? <CaretUp /> : <CaretDown />;
      iconDirectionForOrder = <Sort />;
      iconDirectionForGroup = <Sort />;
    } else if (sortMethod === 'group') {
      iconDirectionForGroup = sortDirection ? <CaretUp /> : <CaretDown />;
      iconDirectionForCustomer = <Sort />;
      iconDirectionForOrder = <Sort />;
    }
    const buttonTitle = {
      RetailCustomers: 'ADD CUSTOMER',
      Customers: 'ADD CUSTOMER',
      'Availability Lists': 'Vendor',
      Stores: 'ADD NEW VENDOR',
      Vendors: 'ADD VENDOR',
    }[title];
    const sectionTitle = {
      RetailCustomers: 'Consumers / Invoice History',
      Customers: 'Customers / Invoice History',
      Vendors: 'Vendors / Invoice History',
      'Availability Lists': '',
      Stores: '',
    }[title];
    const saveButtonTitle = {
      RetailCustomers: 'Add Customer And Send Invite',
      Customers: 'Add Customer And Send Invite',
      Vendors: 'Add Vendor And Send Invite',
    }[title];
    const perPage = paginationOptions.itemsPerPage;
    const pageCount = Math.max(Math.ceil(contacts.length / perPage), 1);
    const showComposer = (!isRestaurant && !isConsumer) && (title === 'Vendors' || title === 'Customers' || title === 'RetailCustomers');
    const paginatedContacts = ((isDistributor && type === 'stores') || showComposer)
      ? contacts.slice((currentPageIndex - 1) * perPage, currentPageIndex * perPage)
      : contacts;
    const showGoToUrl = !contactsRequesting && paginatedContacts.length === 0;

    return (
      <div className="order-sheets-page">
        <HeaderTitle>
          {title === 'RetailCustomers' ? formatMessage('Consumer') : formatMessage(title)}
        </HeaderTitle>
        <Helper name={helper} />
        {
          showComposer && (
            <Composer
              isVendor={isVendor}
              userContacts={contacts}
              isRetailPage={isRetailPage}
            />
          )
        }
        {
          ((isDistributor && type === 'stores') || showComposer) && (
            pageCount > 1 ? (
              <PaginationContainer>
                <Pagination
                  active={currentPageIndex}
                  batchCount={3}
                  count={pageCount}
                  light
                  onPageClick={this.onPageClick}
                />
              </PaginationContainer>
            ) : (
              <PaginationContainer>
                {null}
              </PaginationContainer>
            )
          )
        }
        <SearchComponent
          cancelSearch={this.onCancelSearch}
          placeholder={title === 'Order' || isVendor
            ? formatMessage('Vendors') : formatMessage('Customers')}
          search={debounce(this.onSearchText, 500)}
          searchText={searchText}
        />
        {sectionTitle && <div className="section-title mr-2 d-lg-up-none">{sectionTitle}</div>}
        <div className={`myCustomer-info ${title === 'Availability Lists' ? 'available-list' : ''}`}>
          {sectionTitle && <div className="section-title mr-2 d-md-down-none">{sectionTitle}</div>}
          <div className="customer-actions">
            {title === 'Availability Lists' && (
              <div className="customer-sort d-md-up-none">
                <Button
                  classes={{ label: classes.label }}
                  onClick={this.onSortByVendor}
                  variant="text"
                >
                  {label[0]}
                  {iconDirectionForCustomer}
                </Button>
              </div>)
            }
            {
              (title !== 'Sales Sheets' && title !== 'Order') && (
                <div>
                  <Tooltip tooltip={formatMessage(addTooltip)}>
                    <span>
                      <Button
                        classes={{
                          label: title === 'Availability Lists' ? classes.actionAvailableListBtnLabel : classes.actionBtnLabel,
                          root: title === 'Availability Lists' ? classes.actionAvailableListBtn : classes.actionBtn,
                        }}
                        disabled={readOnly}
                        onClick={this.addCustomer}
                        variant="contained"
                      >
                        {title !== 'Availability Lists' ? buttonTitle : ''}
                        <AddIcon />
                      </Button>
                    </span>
                  </Tooltip>
                  {title === 'Availability Lists' ? buttonTitle : ''}
                </div>)
            }
            {!isConsumer && (
              <div className={`customer-sort ${title === 'Availability Lists' ? ' d-md-down-none' : ''}`}>
                <Button
                  classes={{ label: classes.label }}
                  onClick={this.onSortByVendor}
                  variant="text"
                >
                  {label[0]}
                  {iconDirectionForCustomer}
                </Button>
              </div>
            )}
            {
              showGoToUrl && (isRestaurant || isConsumer) && title === 'Order' && (
                <div
                  className="goto-vendors-page"
                >
                  <span>GO TO&nbsp;</span>
                  <span
                    onClick={() => push('/vendors')}
                    style={{
                      cursor: 'pointer',
                      color: '#359aff',
                    }}
                  >
                    VENDOR'S PAGE&nbsp;
                  </span>
                  <span>TO ADD VENDORS</span>
                </div>
              )
            }
            {
              (isRestaurant || isConsumer) && title === 'Vendors' && !isMobile && (
                <div
                  className="goto-order-sheet-page"
                >
                  <span>GO TO&nbsp;</span>
                  <span
                    onClick={() => push('/order')}
                    style={{
                      cursor: 'pointer',
                      color: '#359aff',
                    }}
                  >
                    ORDER PAGE&nbsp;
                  </span>
                  <span>TO PLACE AN ORDER</span>
                </div>
              )
            }
          </div>
          <div style={{ marginLeft: sectionTitle ? 'auto' : 0 }} className="customer-search-bar">
            <div className="update-sort d-md-down-none">
              {
                (type === 'stores') && (
                  <Button
                    classes={{ label: classes.sort }}
                    onClick={this.onSortUpdates}
                    variant="text"
                  >
                    <span className="d-md-down-none">{formatMessage('Updates')}</span>
                    {iconDirectionForOrder}
                  </Button>
                )
              }
            </div>
            {
              (type === 'stores' && storeNotificaitonCount > 0) && (
                <Tooltip tooltip={formatMessage('CLEAR NOTIFICATIONS')}>
                  <Badge
                    badgeContent={storeNotificaitonCount}
                    classes={{ badge: classes.badgeBtn }}
                  >
                    <Button
                      classes={{
                        label: classes.actionBtnLabel,
                        root: classes.markAsReadBtn,
                      }}
                      onClick={() => this.props.markNotificationAsRead(lastStoreNotification.id)}
                      variant="contained"
                    >
                      <span className="d-md-down-none">{formatMessage('clear all notifications')}</span>
                      <span className="d-md-up-none">{formatMessage('Clear')}</span>
                      
                    </Button>
                  </Badge>
                </Tooltip>
              )
            }
            {title === 'Availability Lists' && (
              <div className="update-sort d-md-up-none">
                {
                  (type === 'stores') && (
                    <Button
                      classes={{ label: classes.sort }}
                      onClick={this.onSortUpdates}
                      variant="text"
                    >
                      <span className="d-md-down-none">{formatMessage('Updates')}</span>
                      {iconDirectionForOrder}
                    </Button>
                  )
                }
              </div>)
            }
            {(title === 'Vendors' || title === 'Customers' || title === 'RetailCustomers') && !isConsumer &&
              <div className="group-sort">
                <Button
                  classes={{ label: classes.label }}
                  onClick={this.onSortByGroup}
                  variant="text"
                >
                  {label[1]}
                  {iconDirectionForGroup}
                </Button>
              </div>
            }
            {!isConsumer && (
              <div style={{ marginLeft: 0 }} className={`customer-other-bar ${title === 'Availability Lists' ? ' d-md-down-none' : ''}`}>
                <Tooltip tooltip={formatMessage('Refresh Page')}>
                  <IconButton onClick={this.onReload}>
                    <Refresh />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        <AddSourceDialog
          createItem={this.addSourceItem}
          isVendor={isVendor}
          onClose={this.handleAddCustomerDlgClose}
          open={addCustomerDialogOpen}
          title={formatMessage(addFormTitle)}
          saveButtonTitle={saveButtonTitle}
          isRetailPage={isRetailPage}
        />
        {type === 'stores' && sellerForNotifications &&
          <NotificationsDialog
            notifications={activeNotifications}
            onClose={this.handleNotificationsDlgClose}
            open={notificationsDialogOpen}
            title={`${formatMessage('Updates by')} ${sellerForNotifications.companyName || ''}`}
          />
        }
        <div name="tabs">
          <Paper
            indicator
            loading={contactsRequesting}
            noPadding
            name="tabs"
          >
            {
              (title === 'Vendors' || title === 'Customers' || title === 'RetailCustomers') && (
                <Tabs
                  classes={{
                    indicator: classes.tabIndicator,
                    root: classes.tabsContainer,
                  }}
                  fullWidth
                  onChange={this.handleChangeTab}
                  value={this.state.tabValue}
                >
                  <Tab
                    className="source-tab"
                    classes={{
                      label: classes.tabLabel,
                      root: classes.tab,
                    }}
                    label={
                      <div style={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        marginLeft: -15,
                      }}>
                        <div>{title === 'RetailCustomers' ? 'Consumer Customers' : title}</div>
                        {
                          countOfContacts > 0 && (
                            <Badge
                              badgeContent={countOfContacts}
                              classes={{ badge: classes.notificationBadge }}
                              color="secondary"
                            >
                              <Typography />
                            </Badge>
                          )
                        }
                      </div>
                    }
                    value="normal"
                  />
                  { !isRetailPage && !isConsumer && (
                    <Tab
                      className="source-tab"
                      classes={{
                        label: classes.tabLabel,
                        root: classes.tab,
                      }}
                      label={
                        <div style={{
                          alignItems: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                        }}>
                          <div>{formatMessage(isMobile ? 'INVITES' : 'Invitations')}</div>
                          {
                            countOfInvitations > 0 && (
                              <Badge
                                badgeContent={countOfInvitations}
                                classes={{ badge: classes.notificationBadge }}
                                color="secondary"
                              >
                                <Typography />
                              </Badge>
                            )
                          }
                        </div>
                      }
                      value="invitations"
                    />
                  )}
                  { !isRetailPage && !isConsumer && (
                    <Tab
                      className="source-tab"
                      classes={{
                        label: classes.tabLabel,
                        root: classes.tab,
                      }}
                      label={
                        <div style={{
                          alignItems: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                        }}>
                          <div>{formatMessage(isMobile ? 'SENT' : 'SENT REQUESTS')}</div>
                          {countOfRequests > 0 && (
                            <Badge
                              badgeContent={countOfRequests}
                              classes={{ badge: classes.notificationBadge }}
                              color="secondary"
                            >
                              <Typography />
                            </Badge>
                          )}
                        </div>
                      }
                      value="requests"
                    />
                  )}
                </Tabs>
              )
            }
            {
              paginatedContacts.map((contact, index) => {
                const contactProfile = contact.id ? contact[contactProfileKey] : contact;
                return (
                  <CardComp
                    contact={contact}
                    currentUser={currentUser}
                    expanded={expanded === contactProfile.id}
                    index={index}
                    info={contactProfile}
                    isVendor={isVendor}
                    key={contact.id}
                    userBroadCastGroups={userBroadCastGroups}
                    readContact={onReadContact}
                    reload={this.onReload}
                    searchText={searchText}
                    setExpanded={setExpanded === noop ? (
                      (expanded, callback) =>
                        this.setState({ expanded }, callback())
                    ) : setExpanded}
                    showNotifications={type === 'stores' ? this.showNotifications : noop}
                    title={title}
                    {...restProps}
                  />
                );
              })
            }
          </Paper>
        </div>
        <ScrollToTop
          id="order-table"
          invisibleHeight={400}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  currentUser: currentUserSelector(state),
  ...(props.type === 'stores' ? {
    storeNotificaitonCount: notificationsCountSelector('store')(state),
    lastStoreNotification: lastNotificationSelector('store')(state),
  } : {}),
  ...selectState('users', 'userBroadCastGroups')(state, 'userBroadCastGroups'),
});

const mapDispatchToProps = dispatch => ({
  ...dispatchRestMaker([
    [broadCastGroupActions, 'userBroadCastGroup'],
  ])(dispatch),
  markNotificationAsRead: id => dispatch(markNotificationAsRead(id)),
});

export default compose(
  setDisplayName('ContactsList'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
)(ContactsList);
